<div class="row">
  <h2 aria-controls="amountToDeclare">
    Montant à déclarer
  </h2>
  <table class="table table-light">
    <thead>
      <tr>
        <th rowspan="2" scope="col">Biens transférés</th>
        <th rowspan="2" scope="col">Gain en capital (perte en capital)</th>
        <th rowspan="2" scope="col">Gain en capital imposable (perte en capital déductible)</th>
        <th scope="col">Revenus de biens</th>
        <th colspan="2" scope="col">Revenu d'entreprise</th>
        <th rowspan="2" scope="col">Dividende réputé</th>
      </tr>
      <tr>
        <th scope="col">Récupération d'amortissement (perte finale)</th>
        <th scope="col">Inventaire</th>
        <th scope="col">Récupération d'amortissement (perte finale)</th>
      </tr>
    </thead>
    <tbody>
      @for (propertyTransferredResults of results.propertiesTransferred; track propertyTransferredResults; let i = $index) {
        <tr>
          <th scope="row">{{ propertyTransferredResults.title }}</th>
          <td>{{ propertyTransferredResults.capitalGain | currencyCents | notAvailable }}</td>
          <td>{{ propertyTransferredResults.taxableCapitalGain | currencyCents | notAvailable }}</td>
          <td>{{ propertyTransferredResults.recapturedAndTerminalLossForInvestment  | currencyCents | notAvailable }}</td>
          <td>{{ propertyTransferredResults.businessIncome | currencyCents | notAvailable }}</td>
          <td>{{ propertyTransferredResults.recapturedAndTerminalLossForBusiness | currencyCents | notAvailable }}</td>
          <td>{{ propertyTransferredResults.deemedDividend | currencyCents | notAvailable }}</td>
        </tr>
      }
      <tr>
        <th scope="row">Total pour tous les biens</th>
        <td>{{ results.totalCapitalGain | currencyCents | notAvailable }}</td>
        <td>{{ results.totalTaxableCapitalGain | currencyCents | notAvailable }}</td>
        <td>{{ results.totalRecapturedAndTerminalLossForInvestment | currencyCents | notAvailable }}</td>
        <td>{{ results.totalBusinessIncome | currencyCents | notAvailable }}</td>
        <td>{{ results.totalRecapturedAndTerminalLossForBusiness | currencyCents | notAvailable }}</td>
        <td>{{ results.totalDeemedDividend | currencyCents | notAvailable }}</td>
      </tr>
    </tbody>
  </table>
</div>